module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section address-section"
  }, [_c('div', {
    staticClass: "description-section"
  }, [_c('p', {
    staticClass: "header"
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section",
    class: {
      actionRight: _vm.actionRight
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "shipping-address-section": "",
      "ma-0": ""
    }
  }, [_c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "first-name": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("First Name"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.first_name),
      expression: "shipping_address.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.shipping_address.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "last-name": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Last Name"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.last_name),
      expression: "shipping_address.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.shipping_address.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "street": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Street Address"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.street_address),
      expression: "shipping_address.street_address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street"
    },
    domProps: {
      "value": (_vm.shipping_address.street_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "street_address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "apartment": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Apt., Floor, Unit etc. (Optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.address_line),
      expression: "shipping_address.address_line"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address_2"
    },
    domProps: {
      "value": (_vm.shipping_address.address_line)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "address_line", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "d-flex": "",
      "justify-space-between": "",
      "city": ""
    }
  }, [_c('div', {
    staticClass: "shipping-address-city-section"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("City / Region"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.city),
      expression: "shipping_address.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.shipping_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isCountryUS) ? _c('div', {
    staticClass: "shipping-address-state-section"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("State"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address-state"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.states,
      "name": "state",
      "item-text": "value",
      "item-value": "value",
      "single-line": "",
      "autocomplete": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.shipping_address.state),
      callback: function($$v) {
        _vm.$set(_vm.shipping_address, "state", $$v)
      },
      expression: "shipping_address.state"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "zipcode": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Zipcode"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping_address.postcode),
      expression: "shipping_address.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "zipcode"
    },
    domProps: {
      "value": (_vm.shipping_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipping_address, "postcode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "country": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Country"), (!_vm.hideRequireIcon) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "name": "country",
      "item-text": "name",
      "item-value": "name",
      "single-line": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.shipping_address.country),
      callback: function($$v) {
        _vm.$set(_vm.shipping_address, "country", $$v)
      },
      expression: "shipping_address.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: {
      sm6: !_vm.singleCol
    },
    attrs: {
      "xs12": "",
      "form-group": "",
      "save-btn": ""
    }
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5afe97e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/address_tab.vue
// module id = 1735
// module chunks = 180